import React, { Component } from 'react'
import Card from './CardUI';

import img4 from "../../assets/WhatsApp Image 2020-06-03 at 19.19.55.jpeg";
import img6 from "../../assets/WhatsApp Image 2020-06-03 at 19.22.47.jpeg";
import img2 from "../../assets/camilo-jimenez-vGu08RYjO-s-unsplash (1).jpg";

export default class Cards extends Component {
    render() {
        return(
            <div className="container-fluid d-flex justify-content-center">
                <div className="row">
                    <div className="col-md-4">
                        <Card imgsrc={img4} title="Rooms Allocation" description="Days to rooms distribution plan" href="/opmngmtmenu/distributionplan"/>
                    </div>
                    <div className="col-md-4">
                        <Card imgsrc={img6} title="Daily Plan Approval" description="Details about the daily plan" href="/nomatch"/>
                    </div>
                    <div className="col-md-4">
                        <Card imgsrc={img2} title="Urgent Operations" description="Schedule urgent cases" href="/nomatch"/>
                    </div>
                </div>
            </div>
        )
    }
}